import { render, staticRenderFns } from "./AutocompleteItem.vue?vue&type=template&id=e0fa8b42&scoped=true&"
import script from "./AutocompleteItem.vue?vue&type=script&lang=js&"
export * from "./AutocompleteItem.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteItem.vue?vue&type=style&index=0&id=e0fa8b42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fa8b42",
  null
  
)

export default component.exports